import { baseApi } from "./baseApi";

export const profileApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({

    // ✅ GET /api/profileCoach
    getProfileCoach: builder.query({
      query: () => "/profileCoach",
      providesTags: ["User"],
    }),

    // ✅ GET /api/profileStagiaire
    getProfileStagiaire: builder.query({
      query: () => "/profileStagiaire",
      providesTags: ["User"],
    }),

    // ✅ POST /api/update-coach
    updateCoach: builder.mutation({
      query: (formData) => ({
        url: "/update-coach",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["User"],
    }),

    // ✅ POST /api/update-stagiaire
    updateProfileStagiaire: builder.mutation({
      query: (formData) => ({
        url: "/update-stagiaire",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const {
  useGetProfileCoachQuery,
  useGetProfileStagiaireQuery,
  useUpdateCoachMutation,
  useUpdateProfileStagiaireMutation,
} = profileApi;